import { cn } from "@/lib/utils";
import { useState } from "react";

interface MascotImageProps {
  variant: 'greeter' | 'thinking' | 'celebrating' | 'welcome';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASSES = {
  sm: 'w-12 h-12',
  md: 'w-20 h-20',
  lg: 'w-32 h-32',
};

const MASCOT_IMAGES = {
  greeter: '/logo/wellness-logo.png',
  thinking: '/logo/wellness-logo.png',
  celebrating: '/logo/wellness-logo.png',
  welcome: '/logo/wellness-logo.png',
};

const MASCOT_ALTS = {
  greeter: 'Wellness Cowgirl logo - lotus flower with cowboy hat',
  thinking: 'Wellness Cowgirl logo - lotus flower with cowboy hat',
  celebrating: 'Wellness Cowgirl logo - lotus flower with cowboy hat',
  welcome: 'Wellness Cowgirl logo - lotus flower with cowboy hat',
};

export const MascotImage = ({ variant, className, size = 'md' }: MascotImageProps) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    console.error(`Failed to load mascot image: ${MASCOT_IMAGES[variant]}`);
    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  if (hasError) {
    return (
      <div className={cn(
        "flex items-center justify-center bg-gradient-to-br from-cowgirl-pink/20 to-dusty-rose/20 rounded-full",
        SIZE_CLASSES[size],
        className
      )}>
        <span className="text-4xl">🪷</span>
      </div>
    );
  }

  return (
    <div className={cn("relative", SIZE_CLASSES[size], className)}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-cowgirl-pink/10 to-dusty-rose/10 rounded-full animate-pulse" />
      )}
      <img 
        src={MASCOT_IMAGES[variant]}
        alt={MASCOT_ALTS[variant]}
        width={size === 'sm' ? 48 : size === 'md' ? 80 : 128}
        height={size === 'sm' ? 48 : size === 'md' ? 80 : 128}
        loading="eager"
        onError={handleError}
        onLoad={handleLoad}
        className={cn(
          "object-contain drop-shadow-lg transition-opacity duration-300",
          isLoading ? "opacity-0" : "opacity-100",
          SIZE_CLASSES[size]
        )}
      />
    </div>
  );
};